var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticClass: "dg-vxe-table", attrs: { gutter: 24 } },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c(
            "el-card",
            { staticStyle: { height: "calc(100vh - 100px)" } },
            [
              _c("div", { staticClass: "title_all" }, [
                _c("strong", { staticClass: "title_left" }, [
                  _vm._v("vxeTable+form组件的demo"),
                ]),
              ]),
              _vm._v(" "),
              _c("vxe-grid", {
                ref: "xGrid",
                attrs: {
                  border: "",
                  stripe: "",
                  resizable: "",
                  "highlight-hover-row": "",
                  height: _vm.height,
                  data: _vm.tableData,
                  "pager-config": _vm.tablePage,
                  columns: _vm.tableColumns,
                },
              }),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: _vm.dialogTitle,
                    visible: _vm.dialogFormVisible,
                  },
                  on: {
                    "update:visible": function ($event) {
                      _vm.dialogFormVisible = $event
                    },
                  },
                },
                [
                  _c("dg-form", {
                    attrs: {
                      "form-data": _vm.formData,
                      "form-items": _vm.formItems,
                      "label-width": "100px",
                    },
                    on: {
                      "update:formData": function ($event) {
                        _vm.formData = $event
                      },
                      "update:form-data": function ($event) {
                        _vm.formData = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.dialogFormVisible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleDialogForm },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }